import axiosInstance from "api"
import { Endpoint } from "api/enpoints.types"
import { AxiosError, AxiosResponse } from "axios"
import { useMutation } from "react-query"

import {
  IAppleLoginArgs,
  IAppleLoginPayload,
  IResponseAppleLogin,
} from "./appleLogin.types"

export const useMutationAppleLogin = ({ option }: IAppleLoginArgs) =>
  useMutation<
    AxiosResponse<IResponseAppleLogin>,
    AxiosError,
    IAppleLoginPayload
  >(
    async (data) =>
      await axiosInstance.post(Endpoint.TEACHER_LOGIN_APPLE, data),
    option,
  )

export const useMutationAppleLoginStudent = ({ option }: IAppleLoginArgs) =>
  useMutation<
    AxiosResponse<IResponseAppleLogin>,
    AxiosError,
    IAppleLoginPayload
  >(
    async (data) =>
      await axiosInstance.post(Endpoint.STUDENTS_LOGIN_APPLE, data),
    option,
  )
